// GENERATED FILE — do not edit.
// Source: packages/content/content/**/*.yaml
// Regenerate with: pnpm --filter @lafayette/content codegen

import type { Catalog } from '../types.js';

export const catalog: Catalog = {
  "rules": {
    "players": {
      "minimum": 2,
      "maximum": 5
    },
    "startingHand": 5,
    "turnDraw": 2,
    "emptyHandDraw": 5,
    "actionsPerTurn": 3,
    "endTurnHandLimit": 7,
    "completeGroupsToWin": 3,
    "requireDistinctGroups": true,
    "reshuffleDiscardWhenDrawPileEmpty": true
  },
  "groups": [
    {
      "id": "blue",
      "label": "Broadway Blue",
      "color": "#1f63ca",
      "onColor": "#ffffff",
      "pattern": "solid",
      "size": 2,
      "rent": [
        3,
        8
      ]
    },
    {
      "id": "green",
      "label": "Garden Green",
      "color": "#1c860a",
      "onColor": "#ffffff",
      "pattern": "diagonal",
      "size": 3,
      "rent": [
        2,
        4,
        7
      ]
    },
    {
      "id": "red",
      "label": "Brick Red",
      "color": "#bb342b",
      "onColor": "#ffffff",
      "pattern": "dots",
      "size": 3,
      "rent": [
        2,
        3,
        6
      ]
    },
    {
      "id": "yellow",
      "label": "Signal Yellow",
      "color": "#d8b025",
      "onColor": "#1b1b1b",
      "pattern": "grid",
      "size": 3,
      "rent": [
        2,
        4,
        6
      ]
    },
    {
      "id": "orange",
      "label": "Sunset Orange",
      "color": "#cd6a23",
      "onColor": "#141414",
      "pattern": "chevron",
      "size": 3,
      "rent": [
        1,
        3,
        5
      ]
    },
    {
      "id": "pink",
      "label": "Neon Pink",
      "color": "#c664aa",
      "onColor": "#141414",
      "pattern": "wave",
      "size": 3,
      "rent": [
        1,
        2,
        4
      ]
    },
    {
      "id": "lightblue",
      "label": "Pool Blue",
      "color": "#6cb6d6",
      "onColor": "#1b1b1b",
      "pattern": "stripe",
      "size": 3,
      "rent": [
        1,
        2,
        3
      ]
    },
    {
      "id": "brown",
      "label": "Cocoa Brown",
      "color": "#8c5332",
      "onColor": "#ffffff",
      "pattern": "crosshatch",
      "size": 2,
      "rent": [
        1,
        2
      ]
    },
    {
      "id": "mint",
      "label": "Mint Green",
      "color": "#c7ecd3",
      "onColor": "#1b1b1b",
      "pattern": "check",
      "size": 2,
      "rent": [
        1,
        2
      ]
    },
    {
      "id": "black",
      "label": "Asphalt Black",
      "color": "#000000",
      "onColor": "#ffffff",
      "pattern": "bar",
      "size": 4,
      "rent": [
        1,
        2,
        3,
        4
      ]
    }
  ],
  "cards": [
    {
      "id": "mortgage-default",
      "title": "Mortgage Default",
      "copies": 2,
      "value": 5,
      "artwork": {
        "figmaNode": "1170:65",
        "alt": "A foreclosure notice taped to a shuttered storefront."
      },
      "description": "Steal a complete strip mall from a player of your choice. (Includes grocery store or residential.) Play into the center to use.",
      "kind": "action",
      "play": {
        "target": {
          "kind": "completeMall",
          "scope": "opponents",
          "count": 1
        },
        "effects": [
          {
            "transferCompleteMall": {
              "from": "target",
              "to": "actor"
            }
          }
        ],
        "cancellable": true,
        "reactionOnly": false,
        "rentModifierOnly": false
      }
    },
    {
      "id": "blame-the-investment-committee",
      "title": "Blame the Investment Committee",
      "copies": 3,
      "value": 4,
      "artwork": {
        "figmaNode": "1170:65",
        "alt": "A boardroom table with every chair pushed back."
      },
      "description": "Cancel an action card that is played against you. Play into the center to use.",
      "kind": "action",
      "play": {
        "target": {
          "kind": "none"
        },
        "effects": [
          {
            "cancelAction": {
              "scope": "self"
            }
          }
        ],
        "cancellable": false,
        "reactionOnly": true,
        "rentModifierOnly": false
      }
    },
    {
      "id": "unsolicited-offer",
      "title": "Unsolicited Offer",
      "copies": 3,
      "value": 3,
      "artwork": {
        "figmaNode": "1170:65",
        "alt": "A postcard offering to buy your building in cash."
      },
      "description": "Take a property from the player of your choice. Cannot be part of a full strip mall. Play into center to use.",
      "kind": "action",
      "play": {
        "target": {
          "kind": "property",
          "scope": "opponents",
          "count": 1,
          "excludeCompleteMalls": true
        },
        "effects": [
          {
            "takeProperty": {
              "from": "target",
              "to": "actor"
            }
          }
        ],
        "cancellable": true,
        "reactionOnly": false,
        "rentModifierOnly": false
      }
    },
    {
      "id": "1031-exchange",
      "title": "1031 Exchange",
      "copies": 3,
      "value": 3,
      "artwork": {
        "figmaNode": "1170:65",
        "alt": "Two deeds crossing over an escrow desk."
      },
      "description": "Swap (tax advantaged!) any property with another player (cannot be part of a full strip mall). Play into center to use.",
      "kind": "action",
      "play": {
        "target": {
          "kind": "propertySwap",
          "scope": "opponents",
          "count": 1,
          "excludeCompleteMalls": true
        },
        "effects": [
          {
            "swapProperty": {
              "actorProperty": "ownSelection",
              "targetProperty": "target"
            }
          }
        ],
        "cancellable": true,
        "reactionOnly": false,
        "rentModifierOnly": false
      }
    },
    {
      "id": "environmental-remediation",
      "title": "Environmental Remediation Needed",
      "copies": 3,
      "value": 3,
      "artwork": {
        "figmaNode": "1170:65",
        "alt": "A soil sampling rig parked on cracked asphalt."
      },
      "description": "Force any player to give you $5M to clean up the PCE in the soil. Play into the center to use.",
      "kind": "action",
      "play": {
        "target": {
          "kind": "player",
          "scope": "opponents",
          "count": 1
        },
        "effects": [
          {
            "createDebt": {
              "debtor": "target",
              "creditor": "actor",
              "amount": 5
            }
          }
        ],
        "cancellable": true,
        "reactionOnly": false,
        "rentModifierOnly": false
      }
    },
    {
      "id": "lunch-with-a-banker",
      "title": "Lunch With a Banker",
      "copies": 3,
      "value": 2,
      "artwork": {
        "figmaNode": "1170:65",
        "alt": "A white tablecloth lunch with a term sheet between the plates."
      },
      "description": "All players give you $2M. Play into the center to use.",
      "kind": "action",
      "play": {
        "target": {
          "kind": "none"
        },
        "effects": [
          {
            "createDebt": {
              "debtor": "allOthers",
              "creditor": "actor",
              "amount": 2
            }
          }
        ],
        "cancellable": true,
        "reactionOnly": false,
        "rentModifierOnly": false
      }
    },
    {
      "id": "go-driving",
      "title": "Go Driving",
      "copies": 10,
      "value": 1,
      "artwork": {
        "figmaNode": "1170:65",
        "alt": "A windshield view of a suburban arterial road."
      },
      "description": "Draw two extra cards. Play into center to use.",
      "kind": "action",
      "play": {
        "target": {
          "kind": "none"
        },
        "effects": [
          {
            "drawCards": {
              "player": "actor",
              "count": 2
            }
          }
        ],
        "cancellable": false,
        "reactionOnly": false,
        "rentModifierOnly": false
      }
    },
    {
      "id": "renegotiate-the-rent",
      "title": "Renegotiate the Rent",
      "copies": 2,
      "value": 1,
      "artwork": {
        "figmaNode": "1170:65",
        "alt": "A lease with the rent line struck through twice."
      },
      "description": "Played with a rent card, this doubles the rent. Play into the center to use.",
      "kind": "action",
      "play": {
        "target": {
          "kind": "none"
        },
        "effects": [
          {
            "doubleRent": {}
          }
        ],
        "cancellable": false,
        "reactionOnly": false,
        "rentModifierOnly": true
      }
    },
    {
      "id": "shadow-anchor-grocery-store",
      "title": "Shadow Anchor Grocery Store",
      "copies": 3,
      "value": 3,
      "artwork": {
        "figmaNode": "1170:65",
        "alt": "A grocery anchor store at the end of the strip."
      },
      "description": "Add onto any strip mall you own to add $3M to the rent value.",
      "kind": "action",
      "play": {
        "target": {
          "kind": "completeMall",
          "scope": "own",
          "count": 1
        },
        "effects": [
          {
            "placeUpgrade": {
              "upgrade": "grocery",
              "rentBonus": 3
            }
          }
        ],
        "cancellable": false,
        "reactionOnly": false,
        "rentModifierOnly": false,
        "upgrade": "grocery"
      }
    },
    {
      "id": "residential-development-on-site",
      "title": "Residential Development On-Site",
      "copies": 2,
      "value": 4,
      "artwork": {
        "figmaNode": "1170:65",
        "alt": "Apartments stacked above the storefronts."
      },
      "description": "Add onto any strip mall you own to add $4M to the rent value. Can only be added to a strip mall that already has a Shadow Anchor Grocery Store.",
      "kind": "action",
      "play": {
        "target": {
          "kind": "completeMall",
          "scope": "own",
          "count": 1,
          "requiresUpgrade": "grocery"
        },
        "effects": [
          {
            "placeUpgrade": {
              "upgrade": "residential",
              "rentBonus": 4
            }
          }
        ],
        "cancellable": false,
        "reactionOnly": false,
        "rentModifierOnly": false,
        "upgrade": "residential"
      }
    },
    {
      "id": "money-1",
      "title": "$1M",
      "copies": 6,
      "value": 1,
      "artwork": {
        "figmaNode": "1170:64",
        "alt": "A one million dollar bank note."
      },
      "kind": "money"
    },
    {
      "id": "money-2",
      "title": "$2M",
      "copies": 5,
      "value": 2,
      "artwork": {
        "figmaNode": "1170:64",
        "alt": "A two million dollar bank note."
      },
      "kind": "money"
    },
    {
      "id": "money-3",
      "title": "$3M",
      "copies": 3,
      "value": 3,
      "artwork": {
        "figmaNode": "1170:64",
        "alt": "A three million dollar bank note."
      },
      "kind": "money"
    },
    {
      "id": "money-4",
      "title": "$4M",
      "copies": 3,
      "value": 4,
      "artwork": {
        "figmaNode": "1170:64",
        "alt": "A four million dollar bank note."
      },
      "kind": "money"
    },
    {
      "id": "money-5",
      "title": "$5M",
      "copies": 2,
      "value": 5,
      "artwork": {
        "figmaNode": "1170:64",
        "alt": "A five million dollar bank note."
      },
      "kind": "money"
    },
    {
      "id": "money-10",
      "title": "$10M",
      "copies": 1,
      "value": 10,
      "artwork": {
        "figmaNode": "1170:64",
        "alt": "A ten million dollar bank note."
      },
      "kind": "money"
    },
    {
      "id": "prop-indian-restaurant",
      "title": "Indian Restaurant",
      "copies": 1,
      "value": 4,
      "artwork": {
        "figmaNode": "1264:2050",
        "alt": "A neon-lit Indian restaurant storefront in a strip mall."
      },
      "kind": "property",
      "group": "blue"
    },
    {
      "id": "prop-karaoke-bar",
      "title": "Karaoke Bar",
      "copies": 1,
      "value": 4,
      "artwork": {
        "figmaNode": "1264:2050",
        "alt": "A karaoke bar with a glowing microphone sign."
      },
      "kind": "property",
      "group": "blue"
    },
    {
      "id": "prop-gluten-free-bakery",
      "title": "Gluten-free Bakery",
      "copies": 1,
      "value": 4,
      "artwork": {
        "figmaNode": "1264:2050",
        "alt": "A bakery window stacked with loaves."
      },
      "kind": "property",
      "group": "green"
    },
    {
      "id": "prop-yoga-studio",
      "title": "Yoga Studio",
      "copies": 1,
      "value": 4,
      "artwork": {
        "figmaNode": "1264:2050",
        "alt": "A yoga studio with mats rolled against the window."
      },
      "kind": "property",
      "group": "green"
    },
    {
      "id": "prop-dog-groomer",
      "title": "Dog Groomer",
      "copies": 1,
      "value": 4,
      "artwork": {
        "figmaNode": "1264:2050",
        "alt": "A dog grooming salon with a poodle in the window."
      },
      "kind": "property",
      "group": "green"
    },
    {
      "id": "prop-boba-tea-salon",
      "title": "Boba Tea Salon",
      "copies": 1,
      "value": 3,
      "artwork": {
        "figmaNode": "1264:2050",
        "alt": "A boba tea shop with oversized cup signage."
      },
      "kind": "property",
      "group": "red"
    },
    {
      "id": "prop-pho-restaurant",
      "title": "Pho Restaurant",
      "copies": 1,
      "value": 3,
      "artwork": {
        "figmaNode": "1264:2050",
        "alt": "A pho restaurant with steam on the windows."
      },
      "kind": "property",
      "group": "red"
    },
    {
      "id": "prop-medi-spa",
      "title": "Medi-Spa",
      "copies": 1,
      "value": 3,
      "artwork": {
        "figmaNode": "1264:2050",
        "alt": "A medical spa with a discreet frosted-glass front."
      },
      "kind": "property",
      "group": "red"
    },
    {
      "id": "prop-hair-salon",
      "title": "Hair Salon",
      "copies": 1,
      "value": 3,
      "artwork": {
        "figmaNode": "1264:2050",
        "alt": "A hair salon with a row of styling chairs."
      },
      "kind": "property",
      "group": "yellow"
    },
    {
      "id": "prop-gas-station",
      "title": "Gas Station",
      "copies": 1,
      "value": 3,
      "artwork": {
        "figmaNode": "1264:2050",
        "alt": "A gas station canopy at the end of the strip mall."
      },
      "kind": "property",
      "group": "yellow"
    },
    {
      "id": "prop-army-recruiting-center",
      "title": "Army Recruiting Center",
      "copies": 1,
      "value": 3,
      "artwork": {
        "figmaNode": "1264:2050",
        "alt": "An army recruiting office with poster-covered windows."
      },
      "kind": "property",
      "group": "yellow"
    },
    {
      "id": "prop-cell-phone-store",
      "title": "Cell Phone Store",
      "copies": 1,
      "value": 2,
      "artwork": {
        "figmaNode": "1264:2050",
        "alt": "A cell phone store draped in carrier banners."
      },
      "kind": "property",
      "group": "orange"
    },
    {
      "id": "prop-chinese-buffet",
      "title": "Chinese Buffet",
      "copies": 1,
      "value": 2,
      "artwork": {
        "figmaNode": "1264:2050",
        "alt": "A Chinese buffet with a long steam table visible inside."
      },
      "kind": "property",
      "group": "orange"
    },
    {
      "id": "prop-pizza-takeout-chain",
      "title": "Pizza Takeout Chain",
      "copies": 1,
      "value": 2,
      "artwork": {
        "figmaNode": "1264:2050",
        "alt": "A pizza takeout counter with a stack of boxes."
      },
      "kind": "property",
      "group": "orange"
    },
    {
      "id": "prop-sub-sandwich-shop",
      "title": "Sub Sandwich Shop",
      "copies": 1,
      "value": 2,
      "artwork": {
        "figmaNode": "1264:2050",
        "alt": "A sub sandwich shop with a bread-shaped sign."
      },
      "kind": "property",
      "group": "pink"
    },
    {
      "id": "prop-massage-parlor",
      "title": "Massage Parlor",
      "copies": 1,
      "value": 2,
      "artwork": {
        "figmaNode": "1264:2050",
        "alt": "A massage parlor with a beaded curtain."
      },
      "kind": "property",
      "group": "pink"
    },
    {
      "id": "prop-nail-salon",
      "title": "Nail Salon",
      "copies": 1,
      "value": 2,
      "artwork": {
        "figmaNode": "1264:2050",
        "alt": "A nail salon with a wall of polish bottles."
      },
      "kind": "property",
      "group": "pink"
    },
    {
      "id": "prop-liquor-store",
      "title": "Liquor Store",
      "copies": 1,
      "value": 2,
      "artwork": {
        "figmaNode": "1264:2050",
        "alt": "A liquor store with a buzzing neon sign."
      },
      "kind": "property",
      "group": "lightblue"
    },
    {
      "id": "prop-plasma-donation-center",
      "title": "Plasma Donation Center",
      "copies": 1,
      "value": 2,
      "artwork": {
        "figmaNode": "1264:2050",
        "alt": "A plasma donation center with a hand-lettered banner."
      },
      "kind": "property",
      "group": "lightblue"
    },
    {
      "id": "prop-barbershop",
      "title": "Barbershop",
      "copies": 1,
      "value": 2,
      "artwork": {
        "figmaNode": "1264:2050",
        "alt": "A barbershop with a spinning pole."
      },
      "kind": "property",
      "group": "lightblue"
    },
    {
      "id": "prop-smoke-shop",
      "title": "Smoke Shop",
      "copies": 1,
      "value": 1,
      "artwork": {
        "figmaNode": "1264:2050",
        "alt": "A smoke shop with tinted windows."
      },
      "kind": "property",
      "group": "brown"
    },
    {
      "id": "prop-laundromat",
      "title": "Laundromat",
      "copies": 1,
      "value": 1,
      "artwork": {
        "figmaNode": "1264:2050",
        "alt": "A laundromat with a row of front-loading machines."
      },
      "kind": "property",
      "group": "brown"
    },
    {
      "id": "prop-dentist",
      "title": "Dentist",
      "copies": 1,
      "value": 2,
      "artwork": {
        "figmaNode": "1264:2050",
        "alt": "A dental office with a smiling tooth logo."
      },
      "kind": "property",
      "group": "mint"
    },
    {
      "id": "prop-chiropractor",
      "title": "Chiropractor",
      "copies": 1,
      "value": 2,
      "artwork": {
        "figmaNode": "1264:2050",
        "alt": "A chiropractic office with a spine diagram in the window."
      },
      "kind": "property",
      "group": "mint"
    },
    {
      "id": "prop-insurance-broker",
      "title": "Insurance Broker",
      "copies": 1,
      "value": 2,
      "artwork": {
        "figmaNode": "1264:2050",
        "alt": "An insurance brokerage with vertical blinds."
      },
      "kind": "property",
      "group": "black"
    },
    {
      "id": "prop-tax-preparer",
      "title": "Tax Preparer",
      "copies": 1,
      "value": 2,
      "artwork": {
        "figmaNode": "1264:2050",
        "alt": "A seasonal tax preparation office."
      },
      "kind": "property",
      "group": "black"
    },
    {
      "id": "prop-real-estate-office",
      "title": "Real Estate Office",
      "copies": 1,
      "value": 2,
      "artwork": {
        "figmaNode": "1264:2050",
        "alt": "A real estate office papered with listings."
      },
      "kind": "property",
      "group": "black"
    },
    {
      "id": "prop-travel-agent",
      "title": "Travel Agent",
      "copies": 1,
      "value": 2,
      "artwork": {
        "figmaNode": "1264:2050",
        "alt": "A travel agency with faded beach posters."
      },
      "kind": "property",
      "group": "black"
    },
    {
      "id": "rent-blue-green",
      "title": "Rent",
      "copies": 2,
      "value": 1,
      "artwork": {
        "figmaNode": "1170:65",
        "alt": "A rent card split between Broadway blue and garden green."
      },
      "description": "All players pay you rent for properties you own in one of these colors. Play into center to use.",
      "kind": "rent",
      "groups": [
        "blue",
        "green"
      ],
      "audience": "allOthers",
      "play": {
        "target": {
          "kind": "rentGroup",
          "count": 1
        },
        "effects": [
          {
            "chargeRent": {
              "debtor": "allOthers",
              "creditor": "actor",
              "group": "target"
            }
          }
        ],
        "cancellable": true,
        "reactionOnly": false,
        "rentModifierOnly": false
      }
    },
    {
      "id": "rent-black-mint",
      "title": "Rent",
      "copies": 2,
      "value": 1,
      "artwork": {
        "figmaNode": "1170:65",
        "alt": "A rent card split between asphalt black and mint green."
      },
      "description": "All players pay you rent for properties you own in one of these colors. Play into center to use.",
      "kind": "rent",
      "groups": [
        "black",
        "mint"
      ],
      "audience": "allOthers",
      "play": {
        "target": {
          "kind": "rentGroup",
          "count": 1
        },
        "effects": [
          {
            "chargeRent": {
              "debtor": "allOthers",
              "creditor": "actor",
              "group": "target"
            }
          }
        ],
        "cancellable": true,
        "reactionOnly": false,
        "rentModifierOnly": false
      }
    },
    {
      "id": "rent-yellow-red",
      "title": "Rent",
      "copies": 2,
      "value": 1,
      "artwork": {
        "figmaNode": "1170:65",
        "alt": "A rent card split between signal yellow and brick red."
      },
      "description": "All players pay you rent for properties you own in one of these colors. Play into center to use.",
      "kind": "rent",
      "groups": [
        "yellow",
        "red"
      ],
      "audience": "allOthers",
      "play": {
        "target": {
          "kind": "rentGroup",
          "count": 1
        },
        "effects": [
          {
            "chargeRent": {
              "debtor": "allOthers",
              "creditor": "actor",
              "group": "target"
            }
          }
        ],
        "cancellable": true,
        "reactionOnly": false,
        "rentModifierOnly": false
      }
    },
    {
      "id": "rent-orange-pink",
      "title": "Rent",
      "copies": 2,
      "value": 1,
      "artwork": {
        "figmaNode": "1170:65",
        "alt": "A rent card split between sunset orange and neon pink."
      },
      "description": "All players pay you rent for properties you own in one of these colors. Play into center to use.",
      "kind": "rent",
      "groups": [
        "orange",
        "pink"
      ],
      "audience": "allOthers",
      "play": {
        "target": {
          "kind": "rentGroup",
          "count": 1
        },
        "effects": [
          {
            "chargeRent": {
              "debtor": "allOthers",
              "creditor": "actor",
              "group": "target"
            }
          }
        ],
        "cancellable": true,
        "reactionOnly": false,
        "rentModifierOnly": false
      }
    },
    {
      "id": "rent-lightblue-brown",
      "title": "Rent",
      "copies": 2,
      "value": 1,
      "artwork": {
        "figmaNode": "1170:65",
        "alt": "A rent card split between pool blue and cocoa brown."
      },
      "description": "All players pay you rent for properties you own in one of these colors. Play into center to use.",
      "kind": "rent",
      "groups": [
        "lightblue",
        "brown"
      ],
      "audience": "allOthers",
      "play": {
        "target": {
          "kind": "rentGroup",
          "count": 1
        },
        "effects": [
          {
            "chargeRent": {
              "debtor": "allOthers",
              "creditor": "actor",
              "group": "target"
            }
          }
        ],
        "cancellable": true,
        "reactionOnly": false,
        "rentModifierOnly": false
      }
    },
    {
      "id": "rent-wild",
      "title": "Wild Rent",
      "copies": 3,
      "value": 3,
      "artwork": {
        "figmaNode": "1170:65",
        "alt": "A rainbow-striped rent card."
      },
      "description": "Force one player to pay you rent for all properties you own in one of these colors. Play into center to use.",
      "kind": "rent",
      "groups": [
        "blue",
        "green",
        "red",
        "yellow",
        "orange",
        "pink",
        "lightblue",
        "brown",
        "mint",
        "black"
      ],
      "audience": "onePlayer",
      "play": {
        "target": {
          "kind": "rentGroupAndPlayer",
          "scope": "opponents",
          "count": 1
        },
        "effects": [
          {
            "chargeRent": {
              "debtor": "target",
              "creditor": "actor",
              "group": "target"
            }
          }
        ],
        "cancellable": true,
        "reactionOnly": false,
        "rentModifierOnly": false
      }
    },
    {
      "id": "wild-blue-green",
      "title": "Property Wildcard",
      "copies": 1,
      "value": 4,
      "artwork": {
        "figmaNode": "1170:67",
        "alt": "A wildcard split between Broadway blue and garden green."
      },
      "kind": "propertyWildcard",
      "groups": [
        "blue",
        "green"
      ]
    },
    {
      "id": "wild-green-black",
      "title": "Property Wildcard",
      "copies": 1,
      "value": 4,
      "artwork": {
        "figmaNode": "1170:67",
        "alt": "A wildcard split between garden green and asphalt black."
      },
      "kind": "propertyWildcard",
      "groups": [
        "green",
        "black"
      ]
    },
    {
      "id": "wild-lightblue-brown",
      "title": "Property Wildcard",
      "copies": 1,
      "value": 1,
      "artwork": {
        "figmaNode": "1170:67",
        "alt": "A wildcard split between pool blue and cocoa brown."
      },
      "kind": "propertyWildcard",
      "groups": [
        "lightblue",
        "brown"
      ]
    },
    {
      "id": "wild-lightblue-black",
      "title": "Property Wildcard",
      "copies": 1,
      "value": 4,
      "artwork": {
        "figmaNode": "1170:67",
        "alt": "A wildcard split between pool blue and asphalt black."
      },
      "kind": "propertyWildcard",
      "groups": [
        "lightblue",
        "black"
      ]
    },
    {
      "id": "wild-black-mint",
      "title": "Property Wildcard",
      "copies": 1,
      "value": 2,
      "artwork": {
        "figmaNode": "1170:67",
        "alt": "A wildcard split between asphalt black and mint green."
      },
      "kind": "propertyWildcard",
      "groups": [
        "black",
        "mint"
      ]
    },
    {
      "id": "wild-orange-pink",
      "title": "Property Wildcard",
      "copies": 2,
      "value": 2,
      "artwork": {
        "figmaNode": "1170:67",
        "alt": "A wildcard split between sunset orange and neon pink."
      },
      "kind": "propertyWildcard",
      "groups": [
        "orange",
        "pink"
      ]
    },
    {
      "id": "wild-red-yellow",
      "title": "Property Wildcard",
      "copies": 2,
      "value": 3,
      "artwork": {
        "figmaNode": "1170:67",
        "alt": "A wildcard split between brick red and signal yellow."
      },
      "kind": "propertyWildcard",
      "groups": [
        "red",
        "yellow"
      ]
    },
    {
      "id": "wild-any",
      "title": "Multicolor Wildcard",
      "copies": 2,
      "value": 0,
      "artwork": {
        "figmaNode": "1170:67",
        "alt": "A rainbow-striped wildcard that fits any strip mall."
      },
      "kind": "propertyWildcard",
      "groups": [
        "blue",
        "green",
        "red",
        "yellow",
        "orange",
        "pink",
        "lightblue",
        "brown",
        "mint",
        "black"
      ]
    }
  ],
  "tenants": [
    "Drive-thru Coffee Shop",
    "Cat Groomer",
    "Vape Emporium",
    "Escape Room",
    "Payday Lender",
    "Trampoline Park",
    "Bail Bonds Office",
    "Bubble Tea Counter",
    "Axe Throwing Bar",
    "Wig Boutique",
    "Halloween Pop-up",
    "Mattress Warehouse",
    "Aquarium Supply",
    "Driving School",
    "Notary Public",
    "Karate Dojo",
    "Vacuum Repair",
    "Fireworks Outlet",
    "Psychic Reader",
    "Bridal Alterations",
    "Guitar Lessons",
    "Frozen Yogurt Bar",
    "Pawn Shop",
    "Ferret Rescue",
    "Discount Optician",
    "Pickleball Pro Shop",
    "Taxidermy Studio",
    "Sourdough Bakery",
    "Vinyl Record Swap",
    "Hot Sauce Boutique",
    "Ghost Kitchen",
    "Sock Outlet",
    "Model Train Depot",
    "Reptile Boarding",
    "Curling Club",
    "Bespoke Candle Bar",
    "Cheese Cave",
    "Puzzle Library",
    "Llama Petting Zoo",
    "Nap Pod Lounge"
  ],
  "figma": {
    "file": "Lafayette Deal",
    "nodes": [
      {
        "node": "1167:497",
        "name": "General Components",
        "covers": "cardBack"
      },
      {
        "node": "1170:64",
        "name": "DONE - Money Cards",
        "covers": "money"
      },
      {
        "node": "1170:65",
        "name": "DONE - Action and Rent Cards",
        "covers": "action"
      },
      {
        "node": "1170:67",
        "name": "DONE - Property Wildcards",
        "covers": "propertyWildcard"
      },
      {
        "node": "1264:2050",
        "name": "DONE - Property Cards",
        "covers": "property"
      },
      {
        "node": "1270:2009",
        "name": "Folio",
        "covers": "rules"
      }
    ]
  }
} as const satisfies Catalog;
